import { Center, Heading, Skeleton, Input, FormLabel, Flex, Button, ButtonGroup } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonBack, Error, Layout } from "../../../components";
import { RootState } from "../../app/mainReducer";
import { useEffect, useState } from 'react';
import { cargaActions } from "../reducer";
import { CargaFinalizada, CargaItem, EntregaCardList } from "../components";
import config from "../../../utils/config";
import { useNavigate, useParams } from "react-router-dom";
import { getOrdemEntrega } from "../types/carga_item";
import type CargaItemType from "../types/carga_item";

const CargaItemList = () => {
  const isLoading = useSelector((state: RootState) => state.carga.isLoading);
  const carga = useSelector((state: RootState) => state.carga.carga);
  const cargas = useSelector((state: RootState) => state.carga.cargas);
  const error = useSelector((state: RootState) => state.carga.error || '');
  const networkOnline = useSelector((state: RootState) => state.login.networkOnline || false);

  const { ukey } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!ukey) return;

    const cargaEncontrada = cargas?.find((i) => i.j14_ukey == ukey);

    if (cargaEncontrada) {
      dispatch(cargaActions.cargaRequestSuccess(cargaEncontrada))
      return;
    }

    if (carga && carga.j14_ukey == ukey) {
      return;
    }

    if (networkOnline) {
      dispatch(cargaActions.cargaRequest({ ukey }));
    } else {
      dispatch(cargaActions.cargasError('Não é possível buscar as entregas, você está sem internet.'));
    }
  }, [dispatch, cargaActions, cargas, ukey])

  const search = () => {
    if (networkOnline) {
      if (!ukey) return;

      dispatch(cargaActions.cargaRequest({ ukey }));
    }
  }
  const [filtro, setFiltro] = useState("");
  const [ordenarPor, setOrdenarPor] = useState<"entrega" | "nota">("entrega");

  const getItensFiltrados = (): CargaItemType[] => {
    if (!carga?.itens) return [];

    if (!filtro) return carga.itens;

    return carga.itens.filter((i) => {
      return i.cliente_fantasia.toLowerCase().includes(filtro.toLowerCase()) ||
        i.cliente_razao_social.toLowerCase().includes(filtro.toLowerCase()) ||
        i.nota_numero.toLowerCase().includes(filtro.toLowerCase());
    });
  };

  const itensFiltrados = getItensFiltrados();
  const hasOrdemEntrega = itensFiltrados.some((i) => getOrdemEntrega(i) > 0);

  const getItens = (): CargaItemType[] => {
    const itens = [...itensFiltrados];
    if (hasOrdemEntrega && ordenarPor === "entrega") {
      itens.sort((a, b) => {
        const ordA = getOrdemEntrega(a);
        const ordB = getOrdemEntrega(b);
        if (ordA !== ordB) return ordA - ordB;
        return (a.nota_numero || "").localeCompare(b.nota_numero || "");
      });
    } else {
      itens.sort((a, b) => (a.nota_numero || "").localeCompare(b.nota_numero || ""));
    }
    return itens;
  };

  return (
    <Layout showFooter={true} backTo="/cargas" isLoading={isLoading} onSearch={search} title={<ButtonBack to="/cargas" />}>
      <>
        <Center mt={1} mb={2}>
          <Heading>{config.listarPorEntrega ? "Entregas" : "Notas"} da carga {carga?.numero}</Heading>
        </Center>

        <Error error={error} />
        {hasOrdemEntrega && (
          <Flex width="full" direction="column" align="center" mb={2} px={2}>
            <FormLabel>Ordenar por:</FormLabel>
            <ButtonGroup isAttached size="sm" variant="outline">
              <Button
                colorScheme="teal"
                variant={ordenarPor === "entrega" ? "solid" : "outline"}
                onClick={() => setOrdenarPor("entrega")}
              >
                Entrega
              </Button>
              <Button
                colorScheme="teal"
                variant={ordenarPor === "nota" ? "solid" : "outline"}
                onClick={() => setOrdenarPor("nota")}
              >
                Nota Fiscal
              </Button>
            </ButtonGroup>
          </Flex>
        )}
        {(getItens().length > 0 || (getItens().length === 0 && filtro)) &&
          <Flex width="full" wrap="wrap">
            <FormLabel mx={2}>Filtrar pelo número da Nota ou Cliente</FormLabel>
            <Input mx={2} mb={4} bg="white" placeholder="Digite o número da nota ou nome do cliente" value={filtro} onChange={(e) => setFiltro(e.target.value)} />
          </Flex>
        }
        {
          isLoading && [1, 2, 3, 4, 5, 6].map((i) => (
            <Skeleton height='90px' mb={1} key={i} />
          ))
        }
        {
          !isLoading && config.listarPorEntrega &&
          <EntregaCardList
            itens={carga?.itens ?? []}
            filtro={filtro}
            ordenarPor={hasOrdemEntrega ? ordenarPor : "nota"}
            onEntregar={(entrega) => navigate(`/entrega/grupo/${ukey}/${entrega.j10_ukey_rota}/opcoes`)}
          />
        }
        {
          !isLoading && !config.listarPorEntrega && getItens().map((carga_item) => (
            <CargaItem onClick={() => navigate(`/entrega/nota/${ukey}/${carga_item.j10_ukey}/opcoes`)} carga_item={carga_item} key={carga_item.nota_numero} />
          ))
        }

        {getItens().length === 0 && !isLoading && !filtro &&
          <CargaFinalizada />
        }
      </>
    </Layout>
  )
}

export default CargaItemList;